export const defaultTextNewItem = `description...`;
